import { Stack, styled } from '@planne-software/uni/mui/material';

export const FooterActions = styled(Stack)({
  flexDirection: 'column',
  width: '100%',
});
